//comment for merge
import style from '../../component/common/style/index.scss';
import { getUiUrl, formatDate, tableDateFormatter, sortDateDesc} from '../../common/utils/index'
import { Tooltip } from './../../component/common/ToolTip/ToolTip';

const gradeScale = ['Group average', 'Date'];
function statuscellClass(params) {
    return (params.value == 'Below' || params.value == -1) ? [style.fontCls, style.raRed].join(" ") : [style.fontCls].join(" ");
}
function groupRowclass(params) {

    return (gradeScale.some(item => params.data.objectType === item)) ? [style.groupedRow, style.top_cls].join(' ') : '';
}
function customTooltip(description) {
    let tooltip = [];
    tooltip.description = description;
    tooltip.tags = [];
    return Tooltip(tooltip);
}

let defaultConfig = {
    columnsdef: [
        {
            headerName: "First name",
            field: "firstName",
            sortable: true, minWidth: 220,
            unSortIcon: true,
            sortingOrder: ['asc'],
            cellClass: groupRowclass,
            wrapText: true,
            autoHeight: true,
            //checkboxSelection: true,
            cellRenderer: (params) => {
                let id = params.data.studentId;
                let name = params.data.firstName;
                let courseId = params.data.courseId;
                let groupId = params.data.groupId;
                let classes = groupRowclass(params);
                let template = (gradeScale.some(item => params.data.objectType === item)) ? `<span class=${classes}>${name} </span>` : `<a href=/student/${id}?courseId=${courseId}&groupId=${groupId}  class="uIdcolumn" >${name}</a>`
                return template;

            }
        },
        {
            headerName: "Last name",
            sort: 'asc',
            field: "lastName",
            sortable: true,
            unSortIcon: true,
            sortingOrder: ['asc', null],
            minWidth: 200,
            wrapText: true,
            autoHeight: true,
            cellClass: groupRowclass,
            cellRenderer: (params) => {
                let id = params.data.studentId;
                let name = params.data.lastName;
                let courseId = params.data.courseId;
                let groupId = params.data.groupId;
                let classes = groupRowclass(params);
                let template = (gradeScale.some(item => params.data.objectType === item)) ? `<span class=${classes}>${name}</span>` : `<a href=/student/${id}?courseId=${courseId}&groupId=${groupId}  class="uIdcolumn" >${name}</a>`
                return template;

            }
        },

        {
            headerName: "Course target", field: "courseTarget", unSortIcon: true, sortingOrder: ['asc'], sortable: true, minWidth: 170, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "On track?",
            field: "studentOnTrack",
            minWidth: 148,
            sortingOrder: ['asc'],
            sortable: true,
            unSortIcon: true,
            wrapText: true,
            autoHeight: true,
            cellClass: statuscellClass,
            headerTooltip: customTooltip(`This assessment result indicates the student is ‘on or above’ or ‘below’ track to meet their course target.
                Based on linear progress from baseline to course target (excluding unit tests).`),
            headerComponentParams: {
                menuIcon: 'fa-bars',
                template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>  &nbsp;' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                    '    <span ref="eText" class="question-tooltip-icon question-tooltip-paddingWidget" role="columnheader"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '  </div>' +
                    '</div>'
            },
            cellRenderer: (params) => {
                let id = params.data.id;
                let onTrack = (params.data.studentOnTrack != null && params.data.studentOnTrack != '') ? params.data.studentOnTrack : '';
                let template = (gradeScale.some(item => params.data.objectType === item) && params.data.objectType != "Date" && onTrack != '') ? `<span >${onTrack} student${onTrack <= 1 ? '' : 's'} on or above</span>` : `<span >${onTrack} </span>`
                return template;
            }

        },
        {
            headerName: "Progress",
            field: "progress",
            minWidth: 150,
            sortingOrder: ['asc'],
            sortable: true,
            unSortIcon: true,
            wrapText: true,
            autoHeight: true,
            cellStyle: { 'text-align': 'center' },
            cellClass: statuscellClass,
            headerTooltip: customTooltip(`Progress is the difference in indicative grades between this assessment and the baseline test (excluding unit tests).`),
            headerComponentParams: {
                menuIcon: 'fa-bars',
                template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>  &nbsp;' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                    '    <span ref="eText" class="question-tooltip-icon question-tooltip-paddingWidget" role="columnheader"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '  </div>' +
                    '</div>'
            },
            cellRenderer: (params) => {
                let id = params.data.id;
                let progress = (params.data.progress != null && params.data.progress != '') ? params.data.progress : '';
                let template = (gradeScale.some(item => params.data.objectType === item) && params.data.objectType != "Date" && progress != '') ? `<span >${progress} student${progress <= 1 ? '' : 's'} making progress</span>` : `<span class=${style.centerCls}>${progress} </span>`
                return template;
            }

        },
        {
            headerName: "Steps", field: "steps", minWidth: 156, sortable: true, sortingOrder: ['asc'], unSortIcon: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Average indicative grade",
            field: "grade",
            minWidth: 270,
            sortingOrder: ['asc'],
            sortable: true,
            unSortIcon: true,
            cellClass: [style.centerCls, style.fontCls].join(" "),
            headerTooltip: customTooltip(`Progress is the difference in indicative grades between this assessment and the baseline test (excluding unit tests).`),
            headerComponentParams: {
                menuIcon: 'fa-bars',
                template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>  &nbsp;' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                    '    <span ref="eText" class="question-tooltip-icon question-tooltip-paddingWidget" role="columnheader"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '  </div>' +
                    '</div>'
            },

        }

    ],
    columnsTitle: {
        firstName: 'First name', lastName: 'Last name', mark: 'Mark', steps: 'Steps', percentage: 'Percentage', target: 'Target', indicativeGrade: 'Indicative grade',
        "maximumMark": "Maximum mark", "assessmentObjective": "Assessment objective",
        "GroupAverage": "Group average", "YearAverage": "Year average", "courseTarget": "Course target"
    }


};

export default defaultConfig;


export const fetchAssessmentsTypes = (rowData) => {
    let assessmentTypeArr = [];
    if (rowData.groupScale != null) {
        rowData.groupScale.map((val) => {
            val.assessment.map((assessments) => {
                let typeExist = assessmentTypeArr.indexOf(assessments.assessmentType);
                if (typeExist == -1) {
                    assessmentTypeArr.push(assessments.assessmentType);
                }
            })

        })
    }

    return assessmentTypeArr;
}
export const convertColumndef = (viewBy, assessmentConfig, customAssessmentTypeArr, schoolId, groupId, courseId, subjectId) => {

    let columnsArray = [];
    let removeColumn = (viewBy == 'indicativeGradeValue') ? 'steps' : 'grade';
    assessmentConfig.columnsdef.map((val) => {
        if (removeColumn != val['field']) {
            if (val['field'] == 'onTrack') {
                val['cellClass'] = statuscellClass;
            }
            columnsArray.push(val)
        }
    })
    let assessmentIdArr = [];
    if (assessmentConfig.rowData.groupScale != null) {
        assessmentConfig.rowData.groupScale.map((val) => {
            let assessmentData = sortDateDesc(val.assessment,'assessmentDate')
            assessmentData.map((assessments) => {

                let isExist = assessmentIdArr.indexOf(assessments.assessmentId);
                let typeExist = customAssessmentTypeArr.indexOf(assessments.assessmentType)
                if (isExist == -1 && typeExist > -1) {
                    let url = getUiUrl() + '/assessment/' + assessments.assessmentId + '?courseId=' + courseId + '&groupId=' + groupId + '&dateTaken=' + assessments.assessmentDate + '&studentYear=&subjectId=' + subjectId + '&schoolId=' + schoolId

                    let columnArr = {
                        headerName: assessments.assessmentName,
                        field: assessments.assessmentId,
                        minWidth: 250,
                        sortingOrder: ['asc'],

                        cellClass: [style.centerCls, style.fontCls].join(" "),
                        headerComponentParams: {
                            menuIcon: 'fa-bars',
                            template:
                                '<div class="ag-cell-label-container" role="presentation">' +
                                '<span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                                '<div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                                '<span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                                '<span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                                '<span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                                '<a class="' + style.uIdcolumn + '" href="' + url + '"> <span ref="eText" class="ag-header-cell-text" role="columnheader"></span></a>&nbsp;' +
                                '<span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                                '</div>' +
                                '</div>'
                        },

                    };

                    columnsArray.push(columnArr);
                    assessmentIdArr.push(assessments.assessmentId);
                }
            })

        })
    }

    return columnsArray;
}

export const convertRowData = (assessmentConfig, viewBy) => {
    let rowsArray = [], pinnedTopRow = [], dateArray = {};
    dateArray['firstName'] = 'Date';
    dateArray['lastName'] = '';
    dateArray['progress'] = '';
    dateArray['studentOnTrack'] = '';
    dateArray['objectType'] = 'Date';
    let assessmentIdArr = [];
    if (assessmentConfig.rowData.groupScale != null) {
        assessmentConfig.rowData.groupScale.map((val) => {

            val.assessment.map((assessments) => {
                val[assessments.assessmentId] = (viewBy == 'indicativeGradeValue') ? assessments.assessmentGrade : assessments.assessmentStep;
                val.rowHeight = 65;
                let isExist = assessmentIdArr.indexOf(assessments.assessmentId);
                if (isExist==-1){
                    dateArray[assessments.assessmentId] = formatDate(assessments.assessmentDate);
                    assessmentIdArr.push(assessments.assessmentId);
                }
                
            })
            pinnedTopRow.push(val);
        })
        pinnedTopRow.splice(0, 0, dateArray);
    }
    if (assessmentConfig.rowData.studentsData != null) {
        assessmentConfig.rowData.studentsData.map((val) => {
            val.assessment.map((assessments) => {
                val[assessments.assessmentId] = (viewBy == 'indicativeGradeValue') ? assessments.assessmentGrade : assessments.assessmentStep;
            })
            rowsArray.push(val);
        })
    }

    return { rowsArray: rowsArray, pinnedTopRow: pinnedTopRow };
}